<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="#"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>{{ title }}</span></li>
            </ol>
        </div>
        <div class="card mt-5" v-loading="loading">
            <div class="card-header bg-info">
                <h3 class="my-0">{{ title }}</h3>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <label>Periodo</label>
                        <el-date-picker v-model="form.month" type="month"
                                        value-format="yyyy-MM" format="MM/yyyy" :clearable="false"></el-date-picker>
                    </div>
                    <div class="col-md-8">
                        <label>Formato</label>
                        <el-select v-model="form.format">
                            <!--                            <el-option key="format_warehouse_purchase" value="format_warehouse_purchase" label="ALMACEN - COMPRAS"></el-option>-->
                            <el-option key="format_incomes" value="format_incomes" label="INGRESOS"></el-option>
                            <el-option key="format_warehouse_purchase" value="format_warehouse_purchase" label="ALMACEN - COMPRAS"></el-option>
                            <!--                            <el-option key="format_cost_sale" value="format_cost_sale" label="COSTO DE VENTAS"></el-option>-->
                        </el-select>
                    </div>
                    <div class="col-12 text-right" style="margin-top: 24px">
                        <el-button type="primary" :loading="loadingSubmit" @click.prevent="clickDownload">
                            <template v-if="loadingSubmit">
                                Generando...
                            </template>
                            <template v-else>
                                Generar
                            </template>
                        </el-button>
                    </div>
                </div>
            </div>
            <!--</div>-->
        </div>
    </div>
</template>

<script>
import queryString from 'query-string'

export default {
    name: 'AccountConcarExport',
    data() {
        return {
            loading: false,
            loadingSubmit: false,
            title: null,
            resource: 'account/concar',
            error: {},
            form: {},
        }
    },
    created() {
        this.initForm();
        this.title = 'Exportar';
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {
                month: moment().format('YYYY-MM'),
                format: 'format_incomes'
            }
        },
        clickDownload() {
            this.loadingSubmit = true;
            let query = queryString.stringify({
                ...this.form
            });
            window.open(`/${this.resource}/download?${query}`, '_blank');
            this.loadingSubmit = false;
        }
    }
}
</script>
